 import { useState, useEffect, useMemo, useCallback, useRef } from 'react';
 import { supabase } from '@/integrations/supabase/client';
import { obtenerMenusBloqueados } from '@/hooks/useMenusBloqueados';
 import { useAuth } from '@/contexts/AuthContext';
 import { Handshake, LucideIcon, ScanSearch } from 'lucide-react';
import { esUsuarioA } from '@/lib/access/usuarioA';
import { hrefDeEntradaAlPortal } from '@/lib/agentPortalRutas';
import {
    LayoutDashboard,
    Building2,
    Building,
    Users,
    Home,
    Package,
    Settings,
    FileText,
    CreditCard,
    User,
    Calendar,
    Briefcase,
    Car,
    Warehouse,
    Eye,
    UserSearch,
    Wallet,
    BadgeDollarSign,
    UserCheck,
    UserCog,
    Scale,
    Receipt,
    Banknote,
    Landmark,
    Shield,
    Wrench,
    Activity,
     KeyRound,
     ScrollText,
     Bot,
     UserPlus,
     BarChart3,
     ClipboardList,
     DollarSign,
     Cog,
     ShoppingCart,
     GitBranch,
     Mail,
     Send,
     History,
     Bell,
     Zap,
    Sparkles,
    LifeBuoy,
    ShieldCheck,
    FileCog,
    CalendarClock,
    CalendarCog,
    CalendarDays,
    MailCheck,
    Megaphone,
    MessagesSquare,
    Smartphone,
    Ticket,
    ConciergeBell,
   } from 'lucide-react';
 
 // Mapeo de iconos por vista_front_end o menu_id
 const iconMapByPath: Record<string, LucideIcon> = {
   '/admin': LayoutDashboard,
   '/admin/proyectos': Building2,
   '/admin/propiedades': Building,
   '/admin/modelos': Home,
   '/admin/vistas': Eye,
   '/admin/estacionamientos': Car,
   '/admin/bodegas': Warehouse,
   '/admin/inventario/precios': DollarSign,
   '/admin/entidades-legales': Shield,
   '/admin/desarrolladores': Building2,
   '/admin/inmobiliarias': KeyRound,
   '/admin/administradoras': Wrench,
   '/admin/notarias': ScrollText,
   '/admin/bancos': Landmark,
   '/admin/prospectos': UserSearch,
   '/admin/compradores': Wallet,
   // Mismo ícono que el badge «Socio» (SocioBadge).
   '/admin/personas/socios': Handshake,
   '/admin/vendedores': BadgeDollarSign,
   '/admin/duenos': UserCheck,
   '/admin/residentes': Home,
   '/admin/agentes': Briefcase,
   '/admin/administradores-personas': UserCog,
   '/admin/representantes-legales': Scale,
   '/admin/representantes-comerciales': Briefcase,
   '/admin/productos': Package,
   '/admin/servicios': Wrench,
   '/admin/categorias-productos': ShoppingCart,
   '/admin/cuentas-cobranza': Receipt,
   '/admin/comisiones': Banknote,
   '/admin/aprobacion-comisiones': BadgeDollarSign,
   '/admin/comisiones-externas': Briefcase,
   '/admin/pagar-comisiones': CreditCard,
  '/admin/pago-proveedores': Banknote,
   '/admin/cuentas-mantenimiento': Wrench,
   '/admin/reservas': Calendar,
   '/admin/notarios/revision-documentacion': FileText,
  '/admin/legal/contratos': FileText,
  '/admin/legal/carta-acuerdos': ScrollText,
  // Legal > Documentos Digitales (antes en Sistema; la ruta no cambió).
  '/admin/configuracion-documentos': FileCog,
  '/admin/documentos-requeridos': FileCog,
   '/admin/usuarios': UserPlus,
   '/admin/usuarios-directivos': Users,
   '/admin/usuarios-clientes': UserCheck,
   '/admin/roles-permisos': Shield,
   '/admin/asistentes-ia': Sparkles,
   '/admin/ayuda-apps': LifeBuoy,
   '/admin/servicios-proveedores': ConciergeBell,
   '/admin/revision-legal': ShieldCheck,
   '/admin/reportes/inventarios': ClipboardList,
   '/admin/reportes/finanzas': DollarSign,
   '/admin/consultas-ia': Bot,
   '/admin/logs-actividad': Activity,
   '/admin/rastreo-clabes-stp': CreditCard,
   '/admin/rastreo-pagos-stp': CreditCard,
   '/admin/configuracion-reportes': Cog,
  '/admin/version-produccion': GitBranch,
  // Inmobiliarias portal
  '/admin/inmobiliarias/mi-informacion': User,
  '/admin/inmobiliarias/mis-agentes': Briefcase,
  '/admin/inmobiliarias/mis-propiedades': Building,
  '/admin/inmobiliarias/mis-ventas': BadgeDollarSign,
  '/admin/administrar-menus': Settings,
  '/admin/comunicacion/administrar-avisos': Megaphone,
  '/admin/comunicacion/enviar-avisos': Send,
  '/admin/comunicacion/ejecuciones': History,
  '/admin/comunicacion/notificaciones-apps': Smartphone,
  // MailCog no existe en lucide-react 0.462: MailCheck es el más cercano.
  '/admin/comunicacion/correos-sistema': MailCheck,
  '/admin/comunicacion/triggers-notificaciones': Zap,
  '/admin/comunicacion/configuracion-citas': CalendarCog,
  '/admin/comunicacion/todas-las-citas': CalendarDays,
  '/admin/comunicacion/chat': MessagesSquare,
  '/admin/comunicacion/eventos': Ticket,
     '/admin/notificaciones-config': Bell,
     '/admin/plantillas-documentos': FileText,
     '/admin/notificaciones-log': ScrollText,
  '/admin/crm/workflow-ofertas': ClipboardList,
  '/admin/crm/dashboard-ejecutivo': BarChart3,
  '/admin/legal-flow/escrituracion/expedientes': FileText,
   // Agent Portal
    '/admin/agent/inicio': LayoutDashboard,
    '/admin/agent/inventario': Building,
    '/admin/agent/prospectos': Users,
    '/admin/agent/pipeline': Activity,
    '/admin/agent/comisiones': Banknote,
    '/admin/agent/perfil': User,
    // Portal Inmobiliaria
    '/admin/portal-inmobiliaria/dashboard': LayoutDashboard,
    '/admin/portal-inmobiliaria/agentes': Users,
    '/admin/portal-inmobiliaria/pipeline': Activity,
    '/admin/portal-inmobiliaria/prospectos': UserSearch,
    '/admin/portal-inmobiliaria/citas': Calendar,
    '/admin/portal-inmobiliaria/comisiones': Banknote,
    '/admin/portal-inmobiliaria/reportes': BarChart3,
    '/admin/portal-inmobiliaria/cuenta': Cog,
    // Portal Cliente
    '/admin/portal-cliente/inicio': LayoutDashboard,
    '/admin/portal-cliente/perfil': User,
    // Portal Cobranza
    '/admin/portal-cobranza/inmuebles': Building2,
    '/admin/portal-cobranza/productos': Package,
    '/admin/portal-cobranza/mantenimiento': Wrench,
    '/admin/portal-cobranza/complementos': Package,
    '/admin/portal-cobranza/cuentas-cobranza': ClipboardList,
    '/admin/portal-cobranza/atencion-clientes': Users,
    '/admin/portal-cobranza/relacion-pagos': CreditCard,
    '/admin/portal-cobranza/ceps-pendientes': Receipt,
    '/admin/portal-cobranza/conciliaciones': Activity,
    '/admin/portal-cobranza/promesas-pago': Banknote,
    '/admin/portal-cobranza/regularizacion': CalendarClock,
    '/admin/portal-cobranza/comunicacion/plantillas': FileText,
    '/admin/portal-cobranza/reportes': BarChart3,
    '/admin/portal-cobranza/validador-movimientos': ScanSearch,
    // Embajadores
    '/admin/embajadores/gestion': Users,
    // Portal Embajadores
    '/admin/portal-embajador/inicio': LayoutDashboard,
    '/admin/portal-embajador/mis-referidos': Users,
    '/admin/portal-embajador/registrar-referido': UserPlus,
    '/admin/portal-embajador/comisiones': Banknote,
    '/admin/portal-embajador/perfil': User,
 };
 
 // Mapeo de iconos por menu_id para los grupos
 const iconMapByMenuId: Record<number, LucideIcon> = {
   1: LayoutDashboard,  // Dashboard
   2: Building2,        // Inventarios
   3: Users,            // Entidades
   4: User,             // Personas
   5: Package,          // Productos
   6: CreditCard,       // Finanzas
   7: Wrench,           // Mantenimientos
   8: ScrollText,       // Notario
   9: Scale,            // Legal
   10: Settings,        // Sistema
   11: BarChart3,       // Reportes
   12: KeyRound,        // Inmobiliarias (portal)
    13: Activity,        // Configuraciones/Logs
    14: Mail,            // Comunicación
    15: Briefcase,        // CRM
      16: User,              // Portal Agente
       17: Building2,          // Portal Inmobiliaria
       18: User,                // Portal Cliente
       19: Receipt,             // Portal Cobranza
       22: UserPlus,            // Embajadores (admin)
       43: ConciergeBell,       // Servicios (servicios para clientes, 20261028044000)
    };
 
export interface DynamicMenuItem {
    title: string;
    href?: string;
    icon: LucideIcon;
    menuId: number;
    children?: DynamicMenuChild[];
    isPortal?: boolean;
    /**
     * Submenús del portal ya filtrados por permisos. El sidebar no los pinta (el
     * portal es un enlace directo); los usa el buscador de menús (Ctrl/⌘+K) para
     * ofrecer cada vista interna sin volver a consultar ni a filtrar permisos.
     */
    portalChildren?: DynamicMenuChild[];
    isRestrictedPortal?: boolean;
    isSoloA?: boolean;
  }
 
export interface DynamicMenuChild {
  title: string;
  href: string;
  icon: LucideIcon;
  submenuId: number;
  disabled?: boolean;
}
 
interface RawSubmenu {
  id: number;
  nombre: string;
  vista_front_end: string | null;
  menu_id: number;
  orden: number;
  solo_usuarioa?: boolean;
  menus: {
    id: number;
    nombre: string;
  } | null;
}
 
// Correo de Usuario A: definición única en `lib/access/usuarioA` (el gate de
// ruta de `useAllowedMenus` usa la misma).
const LOGS_MENU_ID = 13; // Menu de Configuraciones/Logs
const INMOBILIARIAS_PORTAL_MENU_ID = 12; // Menu de Inmobiliarias (portal)
const DASHBOARD_MENU_ID = 1;
const PORTAL_MENU_IDS = new Set([16, 17, 18, 19]); // Portal Agente, Inmobiliaria, Cliente, Cobranza

// Por defecto el sidebar manda al usuario al primer submenú (`orden` más
// bajo) cuando hace click en un portal. Algunos portales operativos deben
// aterrizar directo en su bandeja principal en lugar del primer submenú.
// Cada entrada: regex contra el nombre del menú en BD → URL de destino.
//
// El destino es una PREFERENCIA, no un permiso: solo se usa si la persona tiene
// esa vista entre las suyas. A quien no, se le deja el primer submenú que sí
// puede ver.
const PORTAL_LANDING_URL_OVERRIDES: Array<{ match: RegExp; href: string }> = [
  { match: /^Portal\s+(de\s+)?Administraci[oó]n$/i, href: '/admin/portal-administracion/bandeja-ejecucion' },
];
 
 export function useDynamicMenus() {
   const { profile, isLoading: isAuthLoading, user, permissionVersion } = useAuth();
   const [menuItems, setMenuItems] = useState<DynamicMenuItem[]>([]);
   const [isLoading, setIsLoading] = useState(true);
   const hasLoadedOnce = useRef(false);
   // Correo del perfil con el que se armaron los menús actuales (ver el efecto
   // de abajo): distingue recarga del mismo usuario de un cambio de cuenta.
   const identidadCargadaRef = useRef<string | null>(null);
 
   const isSuperAdmin = profile?.rol_nombre === 'Super Administrador';
   const isProfileStillLoading = !!user && !profile && !isAuthLoading;
   const userEmail = profile?.email;
 
   const fetchDynamicMenus = useCallback(async () => {
     if (!profile?.rol_id) return;
 
     try {
       if (!hasLoadedOnce.current) {
         setIsLoading(true);
       }
 
       // Obtener permiso 'leer'
       const { data: permisoData } = await supabase
         .from('permisos')
         .select('id')
         .eq('nombre', 'leer')
         .single();
 
       if (!permisoData) {
         setMenuItems([]);
         return;
       }
 
       let allowedSubmenuIds: number[] = [];
 
       if (!isSuperAdmin) {
         // Obtener submenus permitidos para este rol
         const { data: permisosData, error: permisosError } = await supabase
           .from('submenus_permisos')
           .select('submenu_id')
           .eq('rol_id', profile.rol_id)
           .eq('permiso_id', permisoData.id)
           .eq('activo', true);
 
         if (permisosError) {
           console.error('Error fetching permissions:', permisosError);
           setMenuItems([]);
           return;
         }
 
         allowedSubmenuIds = permisosData?.map(p => p.submenu_id) || [];
       }
 
        // Obtener todos los submenus activos con su menu padre
        const { data: submenusData, error: submenusError } = await supabase
          .from('submenus')
          .select(`
            id,
            nombre,
            vista_front_end,
            menu_id,
            orden,
            solo_usuarioa,
            menus!inner (
              id,
              nombre
            )
          `)
          .eq('activo', true)
          .order('orden');

    // Obtener menus activos con campo orden
    const { data: menusData } = await supabase
      .from('menus')
      .select('id, nombre, orden, activo')
      .eq('activo', true);

    // Portales individualizados en los que ESTA sesión no está en la lista. El
    // rol ya dijo que puede verlos; esto los quita igualmente, que es el sentido
    // de la individualización. Se tratan como menú apagado para no abrir un
    // segundo camino por el que un submenú pueda colarse.
    const bloqueados = await obtenerMenusBloqueados(permissionVersion);

    // Crear mapa de orden de menus y set de menus activos
    const menuOrdenMap = new Map<number, number>();
    const activeMenuIds = new Set<number>();
    menusData?.forEach(m => {
      if (bloqueados.has(m.id)) return;
      menuOrdenMap.set(m.id, m.orden ?? 100);
      activeMenuIds.add(m.id);
    });
 
       if (submenusError) {
         console.error('Error fetching submenus:', submenusError);
         setMenuItems([]);
         return;
       }
 
          // Filtrar submenus por permisos
          const filteredSubmenus = (submenusData as unknown as RawSubmenu[])?.filter(submenu => {
            // Solo incluir submenus de menus activos
            if (!activeMenuIds.has(submenu.menu_id)) {
              return false;
            }
            
            // Filtrar submenus con solo_usuarioa=true: solo jorge.mendoza puede verlos
            if (submenu.solo_usuarioa && !esUsuarioA(userEmail)) {
              return false;
            }
            
            // Super Admin ve todo (excepto los ya filtrados por solo_usuarioA)
            if (isSuperAdmin) {
              return true;
            }

            // Para otros roles, verificar si tienen permiso
            return allowedSubmenuIds.includes(submenu.id);
          }) || [];
 
       // Agrupar por menu
       const menuMap = new Map<number, { menuNombre: string; children: DynamicMenuChild[] }>();
 
       filteredSubmenus.forEach(submenu => {
         if (!submenu.vista_front_end) return; // Skip submenus sin ruta
 
         const menuId = submenu.menu_id;
         const menuNombre = submenu.menus?.nombre || 'Sin nombre';
 
         if (!menuMap.has(menuId)) {
           menuMap.set(menuId, { menuNombre, children: [] });
         }
 
         const icon = iconMapByPath[submenu.vista_front_end] || FileText;
 
         menuMap.get(menuId)!.children.push({
           title: submenu.nombre,
           href: submenu.vista_front_end,
           icon,
           submenuId: submenu.id,
         });
       });
 
       // Convertir a array de DynamicMenuItem
       const items: DynamicMenuItem[] = [];
 
    // Orden de menus según el campo 'orden' de la tabla menus
    const sortedMenuIds = Array.from(menuMap.keys()).sort((a, b) => {
      const ordenA = menuOrdenMap.get(a) ?? 100;
      const ordenB = menuOrdenMap.get(b) ?? 100;
      return ordenA - ordenB;
    });
 
       sortedMenuIds.forEach(menuId => {
         const menuData = menuMap.get(menuId)!;
          const isPortalByName = /^Portal\s/i.test(menuData.menuNombre);
          const menuIcon =
            iconMapByMenuId[menuId] ||
            (isPortalByName && /embajador/i.test(menuData.menuNombre) ? UserPlus :
            isPortalByName && /escritura/i.test(menuData.menuNombre) ? ScrollText : Settings);
 
          // Dashboard es especial - es un menu sin hijos que lleva directo a /admin
          if (menuId === DASHBOARD_MENU_ID && menuData.children.length === 1) {
            items.push({
              title: menuData.children[0].title,
              href: menuData.children[0].href,
              icon: menuData.children[0].icon,
              menuId,
            });
          } else if ((PORTAL_MENU_IDS.has(menuId) || isPortalByName) && menuData.children.length > 0) {
            // Portales: enlace directo al primer submenú, sin desplegable
            // Verificar si TODOS los submenus originales del menú tienen solo_usuarioa=true
            const allSubmenusOfMenu = (submenusData as unknown as RawSubmenu[])?.filter(s => s.menu_id === menuId && s.vista_front_end) || [];
            const allSoloUsuarioA = allSubmenusOfMenu.length > 0 && allSubmenusOfMenu.every(s => s.solo_usuarioa === true);
            // El override solo vale si ESTA persona puede entrar ahí.
            // `menuData.children` ya viene filtrado por sus permisos, así que
            // basta con buscar la ruta entre ellos.
            //
            // Sin esa comprobación, el enlace mandaba a todos a la bandeja del
            // portal aunque no la tuvieran: a un Agente Interno (rol 9) con
            // permiso SOLO en el Dashboard de Alta Dirección se le daba el
            // permiso, aparecía el portal en el sidebar, y al entrar chocaba
            // con "Acceso Denegado" de /bandeja. El síntoma ("le doy el
            // dashboard y no lo deja entrar") no apunta a este archivo por
            // ningún lado.
            const overrideCandidato = PORTAL_LANDING_URL_OVERRIDES.find(o =>
              o.match.test(menuData.menuNombre),
            )?.href;
            const overrideHref = overrideCandidato
              && menuData.children.some(c => c.href === overrideCandidato)
              ? overrideCandidato
              : undefined;
            items.push({
              title: menuData.menuNombre,
              // En el Portal Agente la primera pestana puede ser solo de la app
              // (Notificaciones): se aterriza en la primera con ruta web.
              href: overrideHref
                ?? hrefDeEntradaAlPortal(menuId, menuData.children.map(c => c.href))
                ?? menuData.children[0].href,
              icon: menuIcon,
              menuId,
              isPortal: true,
              portalChildren: menuData.children,
              isRestrictedPortal: allSoloUsuarioA,
            });
          } else {
            const allSubsOfMenu = (submenusData as unknown as RawSubmenu[])?.filter(s => s.menu_id === menuId && s.vista_front_end) || [];
            const allChildrenSoloA = allSubsOfMenu.length > 0 && allSubsOfMenu.every(s => s.solo_usuarioa === true);
            items.push({
              title: menuData.menuNombre,
              icon: menuIcon,
              menuId,
              children: menuData.children,
              isSoloA: allChildrenSoloA,
            });
          }
       });
 
       // Inventarios → Precios ya no se inyecta a mano: vive en `submenus`
       // ('/admin/inventario/precios') y se resuelve por permisos como el resto.

       setMenuItems(items);
       hasLoadedOnce.current = true;
     } catch (err) {
       console.error('Error in fetchDynamicMenus:', err);
       if (!hasLoadedOnce.current) {
         setMenuItems([]);
       }
     } finally {
       setIsLoading(false);
     }
   }, [profile?.rol_id, isSuperAdmin, userEmail, permissionVersion]);
 
   useEffect(() => {
     if (isAuthLoading) return;
     if (user && !profile) return;
 
     // Cambió la cuenta: los menús del usuario anterior no deben seguir pintados
     // (ni alimentar el redirect a "primera vista permitida") mientras llegan los
     // del nuevo. `hasLoadedOnce` apagaba el spinner y los dejaba vivos.
     const identidad = profile?.email ?? null;
     if (identidadCargadaRef.current !== identidad) {
       identidadCargadaRef.current = identidad;
       hasLoadedOnce.current = false;
       setMenuItems([]);
       setIsLoading(true);
     }
 
     if (!profile?.rol_id) {
       setIsLoading(false);
       return;
     }
 
     fetchDynamicMenus();
   }, [profile?.rol_id, isAuthLoading, user, profile, permissionVersion, fetchDynamicMenus]);
 
   const isLoadingMenus = isAuthLoading || isProfileStillLoading || isLoading;
 
   return {
     menuItems,
     isLoading: isLoadingMenus,
     isSuperAdmin,
   };
 }
